import { Box, styled } from '@mui/material';

export const BodyContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  height: '100%',
  flexGrow: 1,
  minHeight: 0,
  overflowY: 'auto',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '1fr auto',
}));
